<template>
  <div class="restricted-header-container">
    {{ text }}
    <v-tooltip top content-class="restricted-tooltip-content">
      <template v-slot:activator="{ on, attrs }">
        <div
          class="restricted-indicator"
          v-bind="attrs"
          v-on="on"
          aria-label="Staff Only"
          role="img"
        ></div>
      </template>
      <span>{{ tooltip_text }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'RestrictedTableHeaderCell',
  props: {
    text: {
      type: String,
      required: true
    },
    tooltip_text: {
      type: String,
      default: 'Staff Only'
    }
  }
}
</script>

<style lang="scss" scoped>
.restricted-header-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  height: 100%;
}

.restricted-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e53935;
  margin-left: 8px;
  margin-right: 4px;
  cursor: help;
  flex-shrink: 0;
}

::v-deep .restricted-tooltip-content {
  background-color: #e53935 !important;
  color: white !important;
}
</style>
